import RightSideNavigation from "components/RightSideNavigation/RightSideNavigation";
import TwoColumnLayout from "layout/TwoColumnLayout";
import { ProductTemplateDetailSection } from "ProductTemplate/ProductTemplateDetailSection";
import React from "react";
import ProductTemplateDetailOptionsPanel from "./ProductTemplateDetailOptionsPanel";
import { ProductTemplateActivityPanel } from "ProductTemplate/activity/ProductTemplateActivityPanel";
import { useLoaderData } from "react-router";

const ProductTemplateDetailApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ProductTemplateDetailFrontModel>();

  return <TwoColumnLayout>
    <TwoColumnLayout.LeftColumn>
      <TwoColumnLayout>
        <TwoColumnLayout.LeftColumn>
          <ProductTemplateDetailSection
            productGroups={viewModel.productGroups}
            productTemplate={viewModel.productTemplate}
            vatRates={viewModel.vatRates}
          />
        </TwoColumnLayout.LeftColumn>
        <TwoColumnLayout.RightColumn>
          <ProductTemplateDetailOptionsPanel
            productTemplate={viewModel.productTemplate}
            listUrl={viewModel.listUrl}
            optionsPanelData={viewModel.optionsPanel}
          />
          <ProductTemplateActivityPanel
            productTemplateId={viewModel.productTemplate.productTemplateId}
            config={viewModel.activityPanel}
          />
        </TwoColumnLayout.RightColumn>
      </TwoColumnLayout>
    </TwoColumnLayout.LeftColumn>
    <RightSideNavigation
      title={desktopNavigation.rightSideNavigation.title}
      menuItems={desktopNavigation.rightSideNavigation.items}
      currentPage={desktopNavigation.currentPage}
    />
  </TwoColumnLayout>;
};

export default ProductTemplateDetailApp;